import React, { useContext } from 'react';
import {
  Box,
  FloatingNotification as WSRFloatingNotification,
  FloatingNotificationType,
  SectionHelper,
} from '@wix/design-system';
import { StatusAlertFilled } from '@wix/wix-ui-icons-common';
import { observer } from 'mobx-react';
import { dataHooks } from '../../dataHooks';
import { NotificationStore } from '../../utils/notification';
import { AppContextProvider } from '../AppLoader';
import s from '../App/App.scss';

interface INotification {
  store?: NotificationStore;
}

// Themes rendered as a multi-line SectionHelper; the design-system
// FloatingNotification is single-line and truncates longer copy.
const SECTION_HELPER_APPEARANCE: Partial<
  Record<NonNullable<NotificationStore['theme']>, 'danger' | 'warning'>
> = {
  'status-toast-error': 'danger',
  'status-toast-warning': 'warning',
};

export const FloatingNotification: React.FC<INotification> = observer(
  ({ store }) => {
    const {
      rootStore: {
        displayStore: { isMobile, errorToastIconColor },
      },
    } = useContext(AppContextProvider);

    if (!store?.isOpen) {
      return null;
    }

    const appearance = store.theme && SECTION_HELPER_APPEARANCE[store.theme];
    if (appearance) {
      return (
        <Box
          className={s.sectionHelperToast}
          dataHook={dataHooks.floatingNotification.main}
        >
          <SectionHelper
            skin={appearance}
            size={isMobile ? 'small' : 'medium'}
            fullWidth
            showPrefixIcon
            prefixIcon={
              appearance === 'danger' ? (
                <StatusAlertFilled style={{ color: errorToastIconColor }} />
              ) : undefined
            }
          >
            {store.content}
          </SectionHelper>
        </Box>
      );
    }

    return (
      <WSRFloatingNotification
        className={s.floatingNotification}
        dataHook={dataHooks.floatingNotification.main}
        type={store.theme as FloatingNotificationType}
        onClose={store.onClose}
        text={store.content}
        showCloseButton
      />
    );
  },
);
